// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"scrollable-container_scrollableContainer_2KrAN"};